module.exports = __webpack_public_path__ + "img/1499644753.a415cbc7.jpg";